import { useEffect } from 'react'
import { form } from '../../formState'
import { configuredFieldsMutation } from './mutations/configuredFieldsMutation'
import { typeMutation } from './mutations/typeMutation'

const MUTATION_IDS = ['type-change', 'configured-field-change']

export function useAddFormMutations() {
  const formApi = form.useFormApi()

  useEffect(() => {
    // Type mutation
    formApi.addFormMutation('type-change', typeMutation)

    // Configured fields mutation
    formApi.addFormMutation('configured-field-change', configuredFieldsMutation)

    // Cleanup function to remove mutations when component unmounts or formApi changes
    return () => {
      MUTATION_IDS.forEach(id => {
        formApi.removeFormMutation(id)
      })
    }
  }, [formApi])
}
